import { useQuery } from '@tanstack/react-query';

import { listCapabilities } from '~/services/AccommodationService';

import { capabilitiesQueryKeys } from './useGetCapability';

export default function useGetCapabilities() {
  return useQuery({
    queryKey: capabilitiesQueryKeys.list(),
    queryFn: async ({ signal }) => {
      const response = await listCapabilities({ signal });
      return response.result.flags;
    },
  });
}
